<ng-container
  (click)="$event.stopPropagation()"
  *ngFor="let filterItem of filterItems; let i = index; let l = last">
  <div
    class="filter-item"
    [ngClass]="{
    'glow-orange': hoveredDeleteIndex === i,
    'glow-blue': l && newAdded(),
    'non-edit': !editable()
  }">
    <ng-container [formGroup]="filterItem">
      <div class="filter-column">
        <q9-grid-filter-operator-select
          formControlName="operator"
          [operators]="operators"></q9-grid-filter-operator-select>

        <ng-container *ngIf="filterType === 'predefined' || filterType === 'predefinedList'">
          <mat-form-field
            class="q9-form-field q9-full-width"
            appearance="outline"
            subscriptSizing="dynamic"
            floatLabel="auto">
            <mat-label>{{ 'Choose option' | translate }}</mat-label>

            <mat-select
              [multiple]="filterType === 'predefinedList'"
              class="q9-select"
              formControlName="value">
              <mat-option
                class="q9-select-option"
                *ngFor="let option of options"
                (click)="$event.stopPropagation();"
                [value]="option.value">
                {{ option.displayValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>

        <ng-container *ngIf="filterType === 'text'">
          <mat-form-field floatLabel="always">
            <mat-label>{{ 'CORE.GRID.VALUE_LABEL' | translate }}</mat-label>
            <!--          TODO add translate key here for placeholder -->
            <input
              q9Trim
              matInput
              type="text"
              [placeholder]="'Enter text' | translate"
              formControlName="value" />
          </mat-form-field>
        </ng-container>

        <ng-container *ngIf="filterType === 'numeric'">
          <mat-form-field floatLabel="always">
            <mat-label>{{ 'CORE.GRID.VALUE_LABEL' | translate }}</mat-label>
            <!--          TODO add translate key here for placeholder -->
            <input
              q9Trim
              matInput
              type="number"
              [placeholder]="'Enter value' | translate"
              formControlName="value" />
          </mat-form-field>
        </ng-container>

        <ng-container *ngIf="filterType === 'tags'">
          <div class="tags-container">
            <q9-tags-combobox
              formControlName="value"
              [placeholder]="'CORE.TAGS.TAG_LABEL' | translate"
              [config]="tagsConfig"
              (changeTags)="updateTags($event)"
              [limit]="maxTags"></q9-tags-combobox>
          </div>
        </ng-container>

        <ng-container *ngIf="filterType === 'date'">
          <q9-datetime-picker
            formControlName="value"
            [label]="'RUBIC_CUBE.DATE' | translate"
            [isRequired]="true"
            [readonly]="true"
            [type]="'date'"
            [placeholder]="'CORE.GRID.CHOOSE_DATE' | translate"></q9-datetime-picker>
          <!--<ng-container *ngIf="filterItem.value.operator === 'range'">
            <div>
              <q9-datetime-picker
                formControlName="secondValue"
                [label]="'RUBIC_CUBE.DATE' | translate"
                [isRequired]="true"
                [readonly]="true"
                [type]="'date'"
                [placeholder]="'some'"></q9-datetime-picker>
            </div>
          </ng-container>-->
        </ng-container>
      </div>

      <ng-container *ngIf="canAddMore()">
        <div class="icons-container">
          <ng-container *ngIf="filterItems.length > 1">
            <div class="delete-icon">
              <q9-icon-button
                icon="delete-def"
                (mouseenter)="hoveredDeleteIndex = i"
                (mouseleave)="hoveredDeleteIndex = null"
                (click)="$event.stopPropagation(); removeFilter(i)"></q9-icon-button>
            </div>
          </ng-container>
          <ng-container *ngIf="l">
            <div
              [matTooltip]="'RUBIC_CUBE.ADD_SAME_ATTRIBUTE' | translate"
              (click)="$event.stopPropagation(); addCombined()"
              class="plus-icon">
              +
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
